var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardK(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2122 27.6946V23.6056C12.2122 22.5655 13.0601 21.7205 14.1106 21.7135H17.9587C19.0143 21.7135 19.8699 22.5606 19.8699 23.6056V23.6056V27.7073C19.8697 28.5903 20.5816 29.312 21.4733 29.3327H24.0387C26.5961 29.3327 28.6693 27.2803 28.6693 24.7485V24.7485V13.1165C28.6556 12.1205 28.1832 11.1851 27.3866 10.5767L18.6129 3.57975C17.0759 2.36144 14.8909 2.36144 13.3538 3.57975L4.61864 10.5894C3.81895 11.1954 3.34579 12.1322 3.33594 13.1292V24.7485C3.33594 27.2803 5.4091 29.3327 7.96649 29.3327H10.5319C11.4457 29.3327 12.1866 28.5993 12.1866 27.6946V27.6946",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardK);
export default __webpack_public_path__ + "static/media/DashboardK.64699e7584a046fdeca6aad32df793d9.svg";
export { ForwardRef as ReactComponent };